module.exports = __webpack_public_path__ + "static/img/255_TO8_2263.d29ad90.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/255_TO8_2263.jpg
// module id = WLEY
// module chunks = 0